import OrdersListItem from "./OrdersListItem";

const OrderList = ({ orders }) => {
	return (
		<>
			{orders &&
				orders.map((order) => <OrdersListItem order={order} key={order.id} />)}
		</>
	);
};

export default OrderList;
